import { string, object, boolean, mixed } from 'yup';
import { translate } from '../Services/translation';
import constants from '../constants';

const userDetailsCompanySchema = object().shape({
    companyName: string().required(translate('js.myaccount.settings.validation.companyname.notempty')),
    vatNumber: string().required(translate('js.myaccount.settings.validation.vatnumber.notempty')),
});

const userDetailsSchema = object().shape({
    country: mixed()
        .required(translate('js.myaccount.settings.validation.country.notempty'))
        .notOneOf([''], translate('js.myaccount.settings.validation.country.notempty')),
    state: mixed()
        .when('country', (country, schema) => {
            const addressCountry = (country && constants?.countries)
                ? constants.countries.find(
                    (c) => c.code == country
                )
                : null;
            return (addressCountry?.countryStates ?? {}).length > 0 
                ? schema
                    .required(translate('js.myaccount.settings.validation.state.notvalid'))
                    .notOneOf([''], translate('js.myaccount.settings.validation.state.notvalid'))
                : schema.notRequired();
    }),
    phoneNumber: string().notRequired(),
    zipCode: string()
    .when('$forceAddress', (forceAddress, schema) => 
        forceAddress
            ? schema.required(translate('js.myaccount.settings.validation.zipcode.notempty'))
            : schema.notRequired()
    ),
    city: string()
        .when('$forceAddress', (forceAddress, schema) => 
            forceAddress
                ? schema.required(translate('js.myaccount.settings.validation.city.notempty'))
                : schema.notRequired()
    ),
    address: string()
        .when('$forceAddress', (forceAddress, schema) => 
            forceAddress
                ? schema.required(translate('js.myaccount.settings.validation.address.notempty'))
                : schema.notRequired()
    ),
    lastName: string()
        .when('$forceAddress', (forceAddress, schema) => 
            forceAddress 
                ? schema.required(translate('js.myaccount.settings.validation.lastname.notempty'))
                : schema.notRequired()
        ),
    firstName: string()
        .when('$forceAddress', (forceAddress, schema) => 
            forceAddress 
                ? schema.required(translate('js.myaccount.settings.validation.firstname.notempty'))
                : schema.notRequired()
        ),
});

const emailChangeSchema = object().shape({
    newEmail: string()
        .required(translate('js.myaccount.settings.validation.email.notempty'))
        .email(translate('js.myaccount.settings.validation.email.notvalid')),
    password: string().required(translate('js.myaccount.settings.validation.currentpassword.notempty')),
});

const passwordChangeSchema = object().shape({
    currentPassword: string().required(translate('js.myaccount.settings.validation.currentpassword.notempty')),
    newPassword: string()
        .required(translate('js.myaccount.settings.validation.newpassword.notempty'))
        .test(
            "new-passwords-match",
            translate('js.myaccount.settings.validation.newpassword.differentfromcurrent'),
            function(value) {
                if (!value) return true;
                return value !== this.parent.currentPassword;
            }
        ),
    confirmNewPassword: string()
        .required(translate('js.myaccount.settings.validation.confirmpassword.notempty'))
        .test(
            "confirm-password-match",
            translate('js.myaccount.settings.validation.confirmpassword.notvalid'),
            function(value) {
                if (!value) return true;
                return value === this.parent.newPassword;
            }
        )
});

export {
    userDetailsCompanySchema,
    userDetailsSchema,
    emailChangeSchema,
    passwordChangeSchema
}